// extracted by mini-css-extract-plugin
export default {"input":"StringMark_input__NmTQZ","input_focused":"StringMark_input_focused__c5Y92","input_error":"StringMark_input_error__zNFFk","input_inactive":"StringMark_input_inactive__hu8jg"};